﻿import React, { forwardRef } from 'react';
import { SliderProvider } from './SliderContext';
import { DsSliderHandle, DsSliderProps } from './Types';
import DsSlider from './DsSlider';

const ReactSliderWrapper = forwardRef<DsSliderHandle, DsSliderProps>(
  (props, ref) => {
    return (
      <SliderProvider>
        <DsSlider {...props} ref={ref}/>
      </SliderProvider>
    );
  }
);

export default ReactSliderWrapper;